import gql from "graphql-tag"



export const SEARCH_USER = gql`
    query searchUser($name:String!){
        searchUser(name:$name){
            channelId
            displayName
            profileImageUrl
        }
    }
`